"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaypalScriptOptions = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
function getPaypalScriptOptions(clientId, debug) {
    const { iso_code: currency } = (0, checkout_frontend_library_1.getCurrency)();
    return {
        'client-id': clientId,
        debug,
        currency,
        'disable-funding': 'credit,card,venmo,sepa,bancontact,eps,giropay,ideal,mybank,p24,sofort',
        'vault': 'true',
        'intent': 'authorize',
        'integration-date': '2020-03-10'
    };
}
exports.getPaypalScriptOptions = getPaypalScriptOptions;
